module.exports = __webpack_public_path__ + "static/media/2.232ef8cd.webp";